import React from "react"
import { Menu } from "antd"
import { Link, StaticQuery, graphql } from "gatsby"
import styled from "@emotion/styled"
import Img from "gatsby-image"

const SidebarMenuContainerOuter = styled.div`
background: #fff;
    border: 1px solid #eee;
    box-shadow: 0 6px 9px #eee;
    padding: 30px;
    margin-bottom: 60px;
`
const SidebarMenuContainerInner = styled.div`
border: 1px solid #ccc;
    padding: 20px;
    position: relative;
    
    .ant-menu-inline{
      border-right: none;
    }
    .ant-menu-item{
      height: auto !important;
      font-size: 16px;
    }
    .ant-menu-item[style]{
      padding-left: 0px !important;
    }
    .ant-menu-item a{
      color: #000;
      padding-left: 10px;
    }
    .ant-menu-submenu .ant-menu-submenu-title{
      color: #b6212a;
      font-weight: 700;
      font-size: 16px;
    }
    .ant-menu-submenu .ant-menu-submenu-title[style]{
      padding-left: 10px !important;
    }
    .ant-menu-submenu .ant-menu-submenu-arrow::before, .ant-menu-submenu:hover .ant-menu-submenu-arrow::before, .ant-menu-submenu .ant-menu-submenu-arrow::after, .ant-menu-submenu:hover .ant-menu-submenu-arrow::after{
      background-image:  linear-gradient(to right, #b6212a 0%,#b6212a 100%);
    }
    .ant-menu-item-only-child{
      font-weight: 700;
    }
    .ant-menu-sub .ant-menu-item-only-child{
      font-weight: 400;
    }
    .ant-menu-item.ant-menu-item-only-child a:hover{
      background-color: transparent;
      color: #000;
    }
    .ant-menu-sub .ant-menu-item.ant-menu-item-only-child a:hover{
      background-color: #b6212a;
      color: #fff;
    }

`
const HeaderSection = styled.div`
margin: 0 0 40px;
    border-bottom: 1px solid #ccc;
    padding-bottom: 30px;
    text-align: center;
    h4{
        font-size: 30px;
        color: #09182d;
    font-weight: 600;
    margin-bottom: 15px;
    letter-spacing: 2px;
    font-family: 'Playfair Display'
    }
`
const createLocalLink = url => {
  if (`#` === url) {
    return null
  }
  return url ? url.replace('https://backend-gatsby.mmklawfirm.com', ``) : url
}

const SubMenu = Menu.SubMenu

const SIDEBARMENU_QUERY = graphql`
fragment MenuFields on WPGraphQL_MenuItem {
    id
    label
    url
    connectedObject {
      __typename
    }
  }
  
  query GET_SIDEBAR_MENU_ITEMS_MOBILE {
    wpgraphql {
      menuItems(where: {location: SIDEBAR_MENU, parentDatabaseId: 0}) {
        nodes {
          ...MenuFields
          childItems {
            nodes {
              ...MenuFields
              
            }
          }
        }
      }
    }
    file(relativePath: {eq: "header-bottom-line.png"}) {
        childImageSharp {
          fixed(width: 56, height: 14) {
              ...GatsbyImageSharpFixed_withWebp_noBase64
          }
        }
      }
  }
`


const renderMenuItem = menuItem => {
  const link = createLocalLink(menuItem.url)
  if (menuItem.childItems && 
      menuItem.childItems.nodes.length) {
        return renderSubMenu(menuItem)
  }
   else {
    return (
      <Menu.Item key={menuItem.label}>
        <Link to={createLocalLink(menuItem.url)}>{menuItem.label}</Link>
      </Menu.Item>
    )
  }
}

const renderSubMenu = menuItem => (
  <SubMenu title={menuItem.label} key={menuItem.label}>
      {menuItem.childItems.nodes.map(item => renderMenuItem(item))}
  </SubMenu>
)

const SidebarMenu = ({ location }) => (
  <StaticQuery
    query={SIDEBARMENU_QUERY}
    render={data => {
      if (data.wpgraphql.menuItems) {
        return (
            <SidebarMenuContainerOuter>
                <SidebarMenuContainerInner>
                    <HeaderSection>
                        <h4>Practice Areas</h4>
                    <Img fixed={data.file.childImageSharp.fixed} />
                    </HeaderSection>
          <Menu
            mode="inline"
            defaultOpenKeys={['Personal Injury']}
          >
            {data.wpgraphql.menuItems.nodes.map(menuItem => {
              if (menuItem.childItems.nodes.length) {
                return renderSubMenu(menuItem)
              } else {
                return renderMenuItem(menuItem)
              }
            })}
          </Menu>
          </SidebarMenuContainerInner>
          </SidebarMenuContainerOuter>
        )
      } else {
        return null
      }
    }}
  />
)

export default SidebarMenu